import * as z from 'zod';
import validator from 'validator';

import { Gender } from 'models/worker/utils/Gender';
import { relationshipTypeFormEnum } from 'forms/next-of-kin';
import { addressForm } from 'forms/address';
import { RelationshipType } from 'models/worker/utils/RelationshipType';

export const genderEnum = z.nativeEnum(Gender);

export interface ICreateWorkerFormData {
    id?: number
    onsiteToken?: string;
    firstName: string;
    middleName: string;
    lastName: string;
    gender: Gender | null;
    dob: Date | null;
    nextOfKin: IWorkerNextOfKinForm;
    phone: string;
    email: string;
    confirmEmail: string;
    address: IWorkerAddressForm;
    agreeToTerms: 'yes';
    photo: string;
    // password: IWorkerPassword;
}

export interface IWorkerPassword {
    password: string;
    verifyPassword: string;
}

export interface IWorkerAddressForm {
    country: string;
    postCode: string;
    state: string;
    street: string;
    town: string;
}

export interface IWorkerNextOfKinForm {
    nokEmail: string;
    nokFirstName: string;
    nokLastName: string;
    nokPhoneNumber: string
    nokRelationship: RelationshipType | null;
}

export const createWorkerNextOfKinForm = z.object({
    nokRelationship: relationshipTypeFormEnum.nullable().refine((val) => val),
    nokEmail: z.string().email(),
    nokFirstName: z.string().min(1),
    nokLastName: z.string().min(1),
    // TODO: account for more phone locales
    nokPhoneNumber: z.string().refine((data) => validator.isMobilePhone(data, 'en-AU'), {message: 'Not a mobile phone'}),
});

export const createWorkerPassword = z.object({
    password: z.string().superRefine((val, ctx) => {
        if (!validator.isStrongPassword(val, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
        })) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                // path: ['password'],
                message: 'minimum',
            });
        }

        if (val.length > 15) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                // path: ['password'],
                message: 'maximum',
            });
        }
    }),
    verifyPassword: z.string()
}).refine((data) => data.password === data.verifyPassword, {
    message: 'match',
    path: ['verifyPassword'], // path of error
});

export const createWorkerForm = z.object({
    firstName: z.string().min(1),
    middleName: z.string(),
    lastName: z.string().min(1),
    gender: genderEnum.nullable().refine((val) => val),
    dob: z.date().nullable().refine((val) => val),
    nextOfKin: createWorkerNextOfKinForm,
    // TODO: account for more phone locales
    phone: z.string().refine((data) => validator.isMobilePhone(data, 'en-AU'), {message: 'Not a mobile phone'}),
    email: z.string().email(),
    confirmEmail: z.string(),
    address: addressForm,
    agreeToTerms: z.literal('yes'),
    photo: z.string().min(1),
    // password: createWorkerPassword
}).refine((data) => data.email === data.confirmEmail, {
    message: 'doesNotMatch',
    path: ['confirmEmail'], // path of error
});


